<ul>
  <li><a routerLink="/character" routerLinkActive="active">Character</a></li>
  <li><a routerLink="/adventure-log" routerLinkActive="active">Log</a></li>

</ul>
